import 'whatwg-fetch';

import Vue from 'vue';
import highlight from './filters/highlight';

import App from './App.vue';
import store from './store';

import Analytics from './plugins/AnalyticsPlugin';
import Lock from './plugins/LockService';

Vue.config.productionTip = false;

Vue.filter('highlight', highlight);
Vue.use(Lock);
Vue.use(Analytics);

window.Office.initialize = () => {
  new Vue({
    render: h => h(App),
    store
  }).$mount('#app');
};
